export const isLfcItem = (item: { props?: { configData: any } }): boolean => item?.props?.configData !== undefined
